"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("elevate-ui/Button"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var ButtonRender = function ButtonRender(_ref) {
  var classes = _ref.classes,
      _ref$content = _ref.content,
      attrs = _ref$content.attrs,
      url = _ref$content.attrs.url,
      isEditor = _ref.internals.isEditor;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.buttonWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    border: "0",
    cellPadding: "0",
    cellSpacing: "0",
    className: classes.buttonTable
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
    className: classes.buttonTd,
    align: "center",
    valign: "middle"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    onClick: function onClick(e) {
      return isEditor && e.preventDefault();
    },
    target: "_blank",
    className: classes.button
  }, attrs.children))))));
};

var styles = function styles(theme) {
  return {
    buttonWrapper: {
      display: "inline-block",
      verticalAlign: "bottom"
    },
    buttonTable: {
      borderCollapse: "separate !important"
    },
    buttonTd: {
      lineHeight: "100%",
      color: function color(_ref2) {
        var attrs = _ref2.content.attrs;
        return attrs && attrs.color;
      },
      fontFamily: function fontFamily(_ref3) {
        var attrs = _ref3.content.attrs;
        return attrs && attrs.fontFamily;
      },
      fontWeight: "bold",
      fontSize: function fontSize(_ref4) {
        var attrs = _ref4.content.attrs;
        return attrs && "".concat(attrs.fontSize || 10, "px");
      },
      letterSpacing: "-.5px",
      backgroundColor: function backgroundColor(_ref5) {
        var attrs = _ref5.content.attrs;
        return attrs && attrs.backgroundColor;
      },
      border: function border(_ref6) {
        var attrs = _ref6.content.attrs;
        return attrs.borderSize > 0 ? "".concat(attrs.borderSize, "px solid ").concat(attrs.borderColor) : null;
      },
      borderRadius: "5px"
    },
    button: {
      display: "block !important",
      borderRadius: "5px",
      borderStyle: "solid",
      borderColor: function borderColor(_ref7) {
        var attrs = _ref7.content.attrs;
        return attrs && attrs.backgroundColor;
      },
      borderTopWidth: function borderTopWidth(_ref8) {
        var attrs = _ref8.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      borderRightWidth: function borderRightWidth(_ref9) {
        var attrs = _ref9.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      borderBottomWidth: function borderBottomWidth(_ref10) {
        var attrs = _ref10.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      borderLeftWidth: function borderLeftWidth(_ref11) {
        var attrs = _ref11.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      },
      color: function color(_ref12) {
        var attrs = _ref12.content.attrs;
        return attrs && attrs.color;
      },
      textDecoration: "none",
      fontFamily: function fontFamily(_ref13) {
        var attrs = _ref13.content.attrs;
        return attrs && attrs.fontFamily;
      },
      fontSize: function fontSize(_ref14) {
        var attrs = _ref14.content.attrs;
        return attrs && "".concat(attrs.fontSize || 10, "px");
      }
    }
  };
};

var _default = (0, _withStyles["default"])(styles)(ButtonRender);

exports["default"] = _default;